// https://stackoverflow.com/a/66332305/412565
export function getRandomId() {
  return URL.createObjectURL(new Blob([])).slice(-36);
}
